<template>
  <b-modal id="addLicenseDepartmentModal" ref="addLicenseDepartmentModal" @show="onModalShow" @close="resetModal" size="xl" scrollable>
    <template slot="modal-title">{{ $t('addLicense') }}</template>
    <b-table show-empty striped hover small class="aco-table" :items="licenses" :fields="licenseFields">
      <template slot="empty">
        <div class="text-center">{{ $t('emptyTable')}}</div>
      </template>
      <template v-slot:cell()="data">
        <span :class="{ 'disabled-cell': hasLicense(data.item) }">{{ data.value }}</span>
      </template>
      <template v-slot:cell(actions)="row">
        <span :class="{ 'disabled-cell': hasLicense(row.item) }">
          <b-button variant="secondary" size="sm" @click.prevent="addLicense(row.item)" :disabled="hasLicense(row.item)">
            {{ $t('add') }}
          </b-button>
        </span>
      </template>
    </b-table>
    <div slot="modal-footer" class="col-md-12">
      <b-button class="float-right" variant="secondary" @click.prevent="resetModal">
        {{ $t('close') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
  import {mapGetters, mapMutations} from 'vuex'
  import BaseComponent from '../../components/BaseComponent'

  export default {
    name: 'AddDepartmentLicenseModal',
    extends: BaseComponent,
    data () {
      return {
        licenses: [],
      }
    },
    computed: {
      ...mapGetters('licenses', { departmentLicenses: 'licenses'}),
      licenseFields () {
        return [
          { key: 'licenseModel', label: this.$t('model'), tdClass: 'text-nowrap', formatter: value => this.translateAlternatives('licenseModels', value) },
          { key: 'channel', label: this.$t('channel'), sortable: false },
          { key: 'productName', label: this.$t('name'), sortable: true },
          { key: 'orderId', label: this.$t('orderId'), sortable: true, tdClass: 'text-nowrap' },
          { key: 'validFrom', label: this.$t('validFrom'), sortable: true, thClass: 'text-nowrap', tdClass: 'text-nowrap', formatter: 'formatDate' },
          { key: 'validTo', label: this.$t('validTo'), sortable: true, thClass: 'text-nowrap', tdClass: 'text-nowrap', formatter: 'formatDate' },
          { key: 'isBundle', label: this.$t('bundle'), formatter: 'translateBooleans' },
          { key: 'actions', label: '' }
        ]
      }
    },
    methods: {
      ...mapMutations('licenses', {
        setOrganizationNumber: 'UPDATE_ORGANIZATION_NUMBER',
        setDepartmentId: 'UPDATE_DEPARTMENT',
      }),
      async onModalShow() {
        this.setOrganizationNumber(this.$route.params.id)
        this.licenses = (await this.$store.dispatch('licenses/getLicenses', false)).response
      },
      resetModal() {
        this.$store.dispatch('licenses/resetCreateLicense')
        this.$bvModal.hide('addLicenseDepartmentModal')
      },
      hasLicense(license) {
        return this.departmentLicenses.some(({ licenseId }) => licenseId === license.licenseId)
      },
      async addLicense (license) {
        try {
          await this.$store.dispatch('organizations/addDepartmentLicense', {
            departmentId: this.$route.params.departmentId,
            licenseId: license.licenseId,
          })
        } catch (error) {
          console.error(error)
          throw error
        } finally {
          setTimeout(async () => {
            this.setDepartmentId(this.$route.params.departmentId)
            this.setOrganizationNumber(null)
            await this.$store.dispatch('licenses/getLicenses')
            this.$bvModal.hide('addLicenseDepartmentModal')
          }, 300)
        }
      }
    },
    i18n: {
      messages: {
        en: {
          addLicense: 'Add license',
          model: 'Model',
        },
        nb: {
          addLicense: 'Legg til lisens',
          model: 'Modell',
        }
      }
    },
  }
</script>
<style>
#addLicenseDepartmentModal .disabled-cell {
  opacity: 0.5;
}
</style>